<app-eddashboard *ngIf="!isUser" class="dashboard dashboard--ed"></app-eddashboard>
<app-user-dashboard *ngIf="isUser" class="dashboard dashboard--user"></app-user-dashboard>
